import React from 'react'

export const CaretDoubleLeft = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 21L11 11L21 1" stroke="var(--brandPrimaryDark)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 21L1 11L11 1" stroke="var(--brandPrimaryDark)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
